// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/billing/v1/create_billing_portal_session.proto (package protos.vision.billing.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/billing/v1/create_billing_portal_session.proto.
 */
export const file_vision_billing_v1_create_billing_portal_session: GenFile = /*@__PURE__*/
  fileDesc("CjV2aXNpb24vYmlsbGluZy92MS9jcmVhdGVfYmlsbGluZ19wb3J0YWxfc2Vzc2lvbi5wcm90bxIYcHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxIoEBCiFDcmVhdGVCaWxsaW5nUG9ydGFsU2Vzc2lvblJlcXVlc3QSUgoGcGFyYW1zGAEgASgLMkIucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkNyZWF0ZUJpbGxpbmdQb3J0YWxTZXNzaW9uUmVxdWVzdC5QYXJhbXMaCAoGUGFyYW1zIpcBCiJDcmVhdGVCaWxsaW5nUG9ydGFsU2Vzc2lvblJlc3BvbnNlElMKBnJlc3VsdBgBIAEoCzJDLnByb3Rvcy52aXNpb24uYmlsbGluZy52MS5DcmVhdGVCaWxsaW5nUG9ydGFsU2Vzc2lvblJlc3BvbnNlLlJlc3VsdBocCgZSZXN1bHQSEgoKcG9ydGFsX3VybBgBIAEoCWIGcHJvdG8z");

/**
 * @generated from message protos.vision.billing.v1.CreateBillingPortalSessionRequest
 */
export type CreateBillingPortalSessionRequest = Message<"protos.vision.billing.v1.CreateBillingPortalSessionRequest"> & {
  /**
   * @generated from field: protos.vision.billing.v1.CreateBillingPortalSessionRequest.Params params = 1;
   */
  params?: CreateBillingPortalSessionRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.CreateBillingPortalSessionRequest.
 * Use `create(CreateBillingPortalSessionRequestSchema)` to create a new message.
 */
export const CreateBillingPortalSessionRequestSchema: GenMessage<CreateBillingPortalSessionRequest> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_create_billing_portal_session, 0);

/**
 * @generated from message protos.vision.billing.v1.CreateBillingPortalSessionRequest.Params
 */
export type CreateBillingPortalSessionRequest_Params = Message<"protos.vision.billing.v1.CreateBillingPortalSessionRequest.Params"> & {
};

/**
 * Describes the message protos.vision.billing.v1.CreateBillingPortalSessionRequest.Params.
 * Use `create(CreateBillingPortalSessionRequest_ParamsSchema)` to create a new message.
 */
export const CreateBillingPortalSessionRequest_ParamsSchema: GenMessage<CreateBillingPortalSessionRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_create_billing_portal_session, 0, 0);

/**
 * @generated from message protos.vision.billing.v1.CreateBillingPortalSessionResponse
 */
export type CreateBillingPortalSessionResponse = Message<"protos.vision.billing.v1.CreateBillingPortalSessionResponse"> & {
  /**
   * @generated from field: protos.vision.billing.v1.CreateBillingPortalSessionResponse.Result result = 1;
   */
  result?: CreateBillingPortalSessionResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.CreateBillingPortalSessionResponse.
 * Use `create(CreateBillingPortalSessionResponseSchema)` to create a new message.
 */
export const CreateBillingPortalSessionResponseSchema: GenMessage<CreateBillingPortalSessionResponse> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_create_billing_portal_session, 1);

/**
 * @generated from message protos.vision.billing.v1.CreateBillingPortalSessionResponse.Result
 */
export type CreateBillingPortalSessionResponse_Result = Message<"protos.vision.billing.v1.CreateBillingPortalSessionResponse.Result"> & {
  /**
   * @generated from field: string portal_url = 1;
   */
  portalUrl: string;
};

/**
 * Describes the message protos.vision.billing.v1.CreateBillingPortalSessionResponse.Result.
 * Use `create(CreateBillingPortalSessionResponse_ResultSchema)` to create a new message.
 */
export const CreateBillingPortalSessionResponse_ResultSchema: GenMessage<CreateBillingPortalSessionResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_create_billing_portal_session, 1, 0);

